export interface DayDescription {
  short: string;
  long: string;
}

export enum DayOfWeek {
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
  Sunday
}

export type AverageDay = 7;

export type ObjectIndexer<T> = {
  [id in DayOfWeek]: T;
};

export type DaysDescription = ObjectIndexer<DayDescription>;

export const daysOfWeekText: DaysDescription = {
  0: {
    short: "Mon",
    long: "Monday"
  },
  1: {
    short: "Tue",
    long: "Tuesday"
  },
  2: {
    short: "Wed",
    long: "Wednesday"
  },
  3: {
    short: "Thu",
    long: "Thursday"
  },
  4: {
    short: "Fri",
    long: "Friday"
  },
  5: {
    short: "Sat",
    long: "Saturday"
  },
  6: {
    short: "Sun",
    long: "Sunday"
  }
};
